import React, { useState, useEffect } from 'react';

import { useRouter } from 'next/router';
import { useQuery, useMutation } from 'react-query';
import { resumeSkillCategoriesEstimate } from 'services/cv';
import { getAccessToken, isUserLoggedIn } from 'utils/authentication';
import { getErrorText } from 'utils/geterrortext';
import ActionButton from '@core/components/actionbutton/ActionButton';
import RadarChartResume from '@core/components/radarchart/RadarChartReport';

import classes from './AnalyzeMyResume.module.scss';
import { InfoCircle } from 'iconsax-react';




const AnalyzeMyResume = ({ refetchMyResume, toast, skill_insights, cv_skill_insights_access_status, showGoPremiumModal }) => {
    const [isAnalyzeStarted, setIsAnalyzeStarted] = useState(false);
    const [analyzeStatus, setAnalyzeStatus] = useState(null);
    const router = useRouter();

    const { data, isLoading, error, refetch } = useQuery(['resumeSkillCategoriesEstimate', getAccessToken(), isUserLoggedIn()], resumeSkillCategoriesEstimate.GET,
        {
            onSuccess: (data) => {
                setAnalyzeStatus(data?.data?.status);
                if (data?.data?.status === 'saved') {
                    refetchMyResume();
                    setIsAnalyzeStarted(false);
                }

            },
            enabled: false,
        });
    const { mutate, isLoading: isMutating } = useMutation(resumeSkillCategoriesEstimate.POST, {
        onSuccess: () => {
            toast('Your resume is being analyzed. We will notify you once the analysis is complete.', 'success');
            setIsAnalyzeStarted(true);
            refetch();
        },
        onError: (error) => {
            toast(getErrorText(error), 'alert');
        },
    });

    useEffect(() => {
        let interval;
        if (isAnalyzeStarted && (analyzeStatus === 'pending')) {
            refetch(); // immediate check
            interval = setInterval(() => {
                refetch();
            }, 10000);
        }
        return () => clearInterval(interval);
    }, [isAnalyzeStarted, analyzeStatus, refetch]);

    const handleAnalyzeClick = () => {
        if (cv_skill_insights_access_status === 'disabled') {
            toast('Resume analysis is currently unavailable. Please try again later.', 'alert');
        }
        else if (cv_skill_insights_access_status === 'subscription_required') {
            showGoPremiumModal();
        }
        else {
            mutate();
        }
    };

    return (
        <div className={classes['wrapper']}>
            <h3>Skill Insights</h3>

            {skill_insights ? (
                <>
                    <RadarChartResume chartData={skill_insights} isSmall={true} />
                    <ActionButton onClick={handleAnalyzeClick} loading={isMutating} disabled={isAnalyzeStarted || cv_skill_insights_access_status === 'disabled'} kind='secondary_main'>Analyze my resume</ActionButton>                   
                </>

            ) : (
                <>
                    <p>We’ll analyze your CV to estimate your strengths across different skill areas and help guide your learning journey.</p>
                    <ActionButton onClick={handleAnalyzeClick} loading={isMutating} disabled={isAnalyzeStarted || cv_skill_insights_access_status === 'disabled'} kind='secondary_main'>Analyze my resume</ActionButton>
                    {analyzeStatus === 'pending' && (
                        <div className={`${classes['pending-analysis']} d-flex align-items-center gap-2 mt-4`}>
                            <InfoCircle size={24} color='#18BBA8' variant='TwoTone' />
                            <p>
                                We're analyzing your resume!
                                Your results will be ready here in 2–3 minutes. Feel free to explore the platform in the meantime.
                            </p>
                        </div>
                    )}
                </>
            )}
        </div>
    );
};


export default AnalyzeMyResume;